ValidateBmi.$inject = ["$rootScope"];export function ValidateBmi($rootScope) {
  "ngInject";

  var ValidateBmi = {
    validate: validate };


  return ValidateBmi;

  function validate(height, weight, mes_system) {
    var maxHeight = 100;
    var minHeight = 50;
    var maxWeight = 500;
    var minWeight = 50;
    var maxBmi = 28;
    var minBmi = 18;
    var weightUnit = 'lbs';

    if (mes_system != 'US') {
      maxHeight = 250;
      minHeight = 125;
      maxWeight = 225;
      minWeight = 30;
      weightUnit = 'kg';
    }

    if (height >= minHeight && height <= maxHeight && weight >= minWeight && weight <= maxWeight) {
      if (mes_system == 'US') {
        var bmi = Math.round(703 * weight / (height * height));
        if (bmi < minBmi) {
          var minBmiWeight = Math.round(minBmi * height * height / 703);
          alert('Min recommended weight is ' + minBmiWeight + ' ' + weightUnit);
          return minBmiWeight;
        } else
        if (bmi > maxBmi) {
          var maxBmiWeight = Math.round(maxBmi * height * height / 703);
          alert('Max recommended weight is ' + maxBmiWeight + ' ' + weightUnit);
          return maxBmiWeight;
        }
      } else
      {
        var bmi = Math.round(weight / (height / 100 * (height / 100)));
        if (bmi < minBmi) {
          var minBmiWeight = Math.round(minBmi * height * height / 10000);
          alert('Min recommended weight is ' + minBmiWeight + ' ' + weightUnit);
          return minBmiWeight;
        } else
        if (bmi > maxBmi) {
          var maxBmiWeight = Math.round(maxBmi * height * height / 10000);
          alert('Max recommended weight is ' + maxBmiWeight + ' ' + weightUnit);
          return maxBmiWeight;
        }
      }
    }
    return null;
  }
}